import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import Searchbar from '../search/Searchbar';
import Toast from '../common/Toast';
import PropTypes from 'prop-types';
import { Spin } from 'antd';

/**
 * Landing Page of the app.
 *
 * @component
 * @category Landing Page
 */

class LandingPage extends Component {
  state = {};

  componentDidMount = () => {
    //Set the search bar height in px.
    this.props.saveCodeSettings({ searchbarHeight: 116 });
  };

  componentWillMount = () => {
    //don't do data polling by uuid if on landing page
    const dataPolling = false;

    this.props.setDataPolling(dataPolling, () => {
      //Get auth params from the url.
      this.props.getInitAuth(this.getRemoteData);
    });

    //Get remote ports json.
    this.props.getRemotePortsJson();
  };

  /**
   * After getting auth params from url, It will just save query params in redux.
   * @returns {void}
   */
  getRemoteData = () => {
    let url = window.location.href;
    this.props.getJSON(url, undefined);
  };

  render() {
    return (
      <div
        style={{
          height: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

          backgroundColor: 'transparent',
          padding: '10px',
        }}
        className="testO1"
      >
        {/* spinner */}
        {/* {this.props.loading && <Spin size="large" className="spinner" />} */}

        {/* show toast message if there is error message */}
        {this.props.errorMessage.trim() && <Toast />}

        {/* Searchbar component */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          className="testR1"
        >
          <Searchbar />
        </div>
      </div>
    );
  }
}

LandingPage.propTypes = {
  /**
   * Global error message
   */
  errorMessage: PropTypes.string,
};

const mapStateToProps = ({ route }) => {
  return {
    errorMessage: route.errorMessage,
  };
};

export default connect(mapStateToProps, actions)(LandingPage);
